// extracted by mini-css-extract-plugin
module.exports = {"rowContainer":"_1zBSNvFc_pA3iUEHh3itEd","isFirstRow":"_2KCY62rIx9hZpRvPmDVYrO","title":"_2NF2XC0zpWNwyZO63FBvT1","body":"XPI9UeZz1MoI1Qgb1KED4"};